<template>
  <div>
    <skinTesting-list v-show="tabType === 1" @handleShow="handleShow" />
    <skinTesting-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import skinTestingList from './list.vue'
import skinTestingShow from './show.vue'
export default {
  components: { skinTestingList, skinTestingShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }
}
</script>

<style>
</style>